import Dates from 'components/Dates';
import { SchoolData } from 'types/dacum/schoolManagement';

export const columns = [
  {
    heading: 'School Name',
    props: 'schoolName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'schoolName'
  },
  {
    heading: 'Business Unit',
    props: 'businessUnitName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'businessUnitName'
  },
  {
    heading: 'Description',
    props: 'description',
    sortable: true,
    active: true,
    disabled: false,
    id: 'description'
  },
  {
    heading: 'Notes',
    props: 'notes',
    sortable: true,
    active: true,
    disabled: false,
    id: 'notes'
  },
  {
    heading: 'Created Date',
    props: ({ dateIn }: SchoolData) => <Dates date={dateIn} />,
    sortable: true,
    active: true,
    disabled: false,
    id: 'dateIn'
  },
  {
    heading: 'Updated Date',
    props: ({ dateUp }: SchoolData) => (dateUp ? <Dates date={dateUp} /> : '-'),
    sortable: true,
    active: true,
    disabled: false,
    id: 'dateUp'
  },
  {
    heading: 'Created By',
    props: 'userIn',
    sortable: true,
    active: true,
    disabled: false,
    id: 'userIn'
  },
  {
    heading: 'Updated By',
    props: ({ userUp }: SchoolData) => userUp || '-',
    sortable: true,
    active: true,
    disabled: false,
    id: 'userUp'
  },
  {
    heading: 'Action',
    props: 'action',
    sortable: false,
    active: true,
    disabled: false,
    id: 'action'
  }
];

export const columnsJobFamily = [
  {
    heading: 'Job Family',
    props: 'jobFamilyName',
    sortable: true,
    active: true,
    disabled: false,
    id: 'jobFamilyName'
  },
  {
    heading: 'Business Unit',
    props: 'businessUnit',
    sortable: true,
    active: true,
    disabled: false,
    id: 'businessUnit'
  }
];
